import dayjs from 'dayjs';
import { v4 as uuid } from 'uuid';

import MetadataFields from '../types/metadataFields.type';

const values: MetadataFields = {
  boolean: false,
  color: '',
  date: dayjs(),
  json: '',
  money: {
    currency_code: 'CAD',
    value: '0',
  },
  single_line_text_field: '',
  string_integer: '',
  url: '',
  dimension: {
    unit: 'in',
    value: '0',
  },
  integer: '0',
  multi_line_text_field: '',
  numeric: '0',
  rating: {
    scale_max: '0',
    scale_min: '0',
    value: '0',
  },
  rich_text_field: '',
  timestamp: dayjs(),
  timezone: '',
  volume: {
    unit: 'oz',
    value: '20.5',
  },
  weight: {
    unit: 'g',
    value: '0',
  },
  tax_definition: [
    {
      id: uuid(),
      tax_code: 'GST',
      multiplier: '0.00',
    },
  ],
  multi_currency_money: [
    {
      id: uuid(),
      value: '0.00',
      currency_code: 'CAD',
    },
  ],
};

const getInitialValueByMetatype = <K extends keyof typeof values>(
  key: K,
  initialValue?: unknown,
): (typeof values)[K] => {
  if (!(key in values)) {
    throw new Error(
      'Metadata id is incorrect or was not provided in "getInitialValueByMetatype.ts"',
    );
  }

  if (initialValue) {
    if (Array.isArray(initialValue) && key !== 'json') {
      const valuesUpdated = {
        ...values,
        [key]: initialValue.map((item: Record<string, unknown>) => ({
          ...item,
          id: uuid(),
        })),
      };

      return valuesUpdated[key];
    }

    if (key === 'json') {
      const valuesUpdated = { ...values, [key]: JSON.stringify(initialValue) };
      return valuesUpdated[key];
    }

    if (key === 'date' || key === 'timestamp') {
      const valuesUpdated = { ...values, [key]: dayjs(initialValue as string) };
      return valuesUpdated[key];
    }

    const valuesUpdated = { ...values, [key]: initialValue };
    return valuesUpdated[key];
  }

  return values[key];
};

export default getInitialValueByMetatype;
